/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import { createContext, PropsWithChildren, useState } from 'react';

export interface ParkedCall {
    slot: string;
    phoneNumber: string;
    callerNameId: string;
    kazooCallId: string;
}

interface CallParkingCtx {
    parkedCalls: Record<string, ParkedCall>;
    startTime: Record<string, number>;
    setParkedCalls: React.Dispatch<React.SetStateAction<Record<string, ParkedCall>>>;
    setStartTime: React.Dispatch<React.SetStateAction<Record<string, number>>>;
}

export const CallParkingContext = createContext<CallParkingCtx>(null!);

export default function CallParkingProvider({ children }: PropsWithChildren<{}>) {
    const [parkedCalls, setParkedCalls] = useState<CallParkingCtx['parkedCalls']>({});
    const [startTime, setStartTime] = useState<Record<string, number>>({});

    return (
        <CallParkingContext.Provider value={{ parkedCalls, startTime, setParkedCalls, setStartTime }}>
            {children}
        </CallParkingContext.Provider>
    );
}
